import { ReactNode } from "react";

export type AppraisalOrderFormErrorProps = {
    errorMessage: ReactNode;
    skipTryAgainMessage?: boolean;
  }

/**
 * Displays an error message for the appraisal order form.
 * @param errorMessage - The error message to display.
 * @param skipTryAgainMessage - Whether to skip the try again message.
 * @returns The error message.
 */
const AppraisalOrderFormError = ({ errorMessage, skipTryAgainMessage }: AppraisalOrderFormErrorProps) => {
    return (
        <>
          {errorMessage} { !skipTryAgainMessage ? <>
          Please try again or <a href="https://hometap.slack.com/archives/CBN5REDQ9">reach out</a> to
          report the issue.</> : null}
        </>
    );
  };

  
export default AppraisalOrderFormError;
  